<app-bluetooth-svg [height]="'32'"
                   [status]="status()"
                   [width]="'32'"
                   style="margin: auto"></app-bluetooth-svg>
